import { createSelector } from 'reselect';
import { State } from 'reducers';
import { Report, ReportId, ReportMap } from 'types';

export type HasReportId = {
    reportId: ReportId | null;
};


const getReportId = <T extends HasReportId>(state: State, props: T) => props.reportId;


export const getReports = (state: State) => state.report.data;

export const isLoadingReports = (state: State) => state.report.loading;

export const getReportsError = (state: State) => state.report.error;

export const getReport: Reselect.OutputParametricSelector<State, HasReportId, Report | null, (dm: ReportMap, id: ReportId) => Report | null> =
    createSelector(
        getReports,
        getReportId,
        (reports, reportId) => {
            // Bail out if the reports haven't been loaded yet
            if (!reports) return null;

            // Bail out if there is no report specified;
            if (reportId === null) return null;

            return reports[`${reportId}`];
        }
    );



// WEBPACK FOOTER //
// ./src/selectors/reportSelectors.ts